import { ROUTES, SETTINGS_ROUTES } from "@/shared/constants/routes";
import { importLazy } from "@/shared/utils/import-lazy";
import { RouteObject } from "react-router-dom";
import SettingsLayout from "../components/layout";
import SettingsMainPage from "../components/main";
import ControlSetEditPage from "../components/control-set-edit";
import ControlSetsList from "../components/control-sets-list";
import QuestionnairesList from "../components/questionnaires-list";
import IntakeFormScreen from "../components/intake-form-screen";

export const SettingsRoutes: RouteObject[] = [
  {
    path: ROUTES.SETTINGS,
    // lazy: importLazy(() => import("@/modules/settings/components/layout")),
    Component: SettingsLayout,
    children: [
      {
        index: true,
        // lazy: importLazy(() => import("@/modules/settings/components/main")),
        Component: SettingsMainPage
      },
      {
        path: SETTINGS_ROUTES.THIRD_PARTY_CONTROL_SETS,
        Component: ControlSetsList,
      },
      {
        path: SETTINGS_ROUTES.THIRD_PARTY_QUESTIONNAIRES,
        Component: QuestionnairesList,
      },
      {
        path: SETTINGS_ROUTES.INTAKE_FORM,
        Component: IntakeFormScreen,
      },
    ],
  },
  // Standalone route for control set editing (full screen, no settings layout)
  {
    path: `${ROUTES.SETTINGS}/control-sets/edit`,
    Component: ControlSetEditPage,
  },
];
